import { useEffect, useState } from 'react'
import { useAuthStore } from '@/stores/auth-store'

export function useAuth() {
  const { user, isLoading, isAuthenticated, role, signInWithGoogle, signOut, fetchProfile } = useAuthStore()
  const [isInitializing, setIsInitializing] = useState(true)

  useEffect(() => {
    const init = async () => {
      await fetchProfile()
      setIsInitializing(false)
    }
    
    if (isLoading) {
      init()
    } else {
      setIsInitializing(false)
    }
  }, [isLoading, fetchProfile])

  return {
    user,
    isLoading: isLoading || isInitializing,
    isAuthenticated,
    role,
    isAdmin: role === 'admin' || role === 'moderator',
    signInWithGoogle,
    signOut,
  }
}
